/**
 *
 * PriorityMediumTag
 *
 */

import React, { memo } from 'react';
import styled from 'styled-components';

import { COLORS } from 'theme';
import { EqualSignIcon } from 'assets/v2/icons';
import Tag from '..';

const StyledTag = styled(Tag)`
  &.MuiChip-root {
    color: ${COLORS.dataRustDark};
    background: ${COLORS.dataRustLight};
    border-color: ${COLORS.dataRust};
    border-radius: ${({ theme }) => theme.borderRadius.secondary};

    &&& .MuiChip-icon path {
      fill: ${COLORS.dataRust};
    }
  }
`;

function PriorityMediumTag(props) {
  return <StyledTag label="Medium" icon={<EqualSignIcon />} {...props} />;
}

export default memo(PriorityMediumTag);
